var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vm.started)?_c('running-VM',{attrs:{"vm":_vm.vm,"arena3d":_vm.arena3d}}):_c('setup-VM',{attrs:{"vm":_vm.vm,"arena3d":_vm.arena3d},on:{"arena3d":function (val) { return (_vm.arena3d = val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }